import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../../../../component-lib/Atoms/heading/EventEHRHeading";
import EditChiefComplaint from "./EditChiefComplaint";
import { useDispatch } from "react-redux";
import { patchChiefComplaintData } from "../../../patientSaga";
import { useParams } from "react-router-dom";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "300px",
    width: "708px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface EventEHREditChiefComplaintDialogProps {
  isOpen: boolean;
  defaultSelectedData?: string;
  dialogHeading: string;
  handleClose: () => void;
}

export default function EventEHREditChiefComplaintDialog({
  isOpen = false,
  handleClose,
  defaultSelectedData,
  dialogHeading = "Your Heading Here...",
}: EventEHREditChiefComplaintDialogProps) {
  const { visitNoteId } = useParams();
  const dispatch = useDispatch();
  const handleSubmitData = (formData: any) => {
    const payload = {
      visitId: visitNoteId,
      apiPayload: {
        chiefComplaints: formData?.chiefComplaint,
      },
    };
    dispatch(patchChiefComplaintData(payload));
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent
          dividers
          style={{ padding: "16px 24px 24px 24px", borderRadius: "8px" }}
        >
          <EditChiefComplaint
            defaultSelectedData={defaultSelectedData}
            getFormData={(formData) => {
              handleSubmitData(formData);
            }}
            handleClose={handleClose}
          />
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
